import React from "react"
import { graphql } from "gatsby"

import styles from "./zeusModules.module.scss"
import Video from "./zeus-modules/video"
import Text from "./zeus-modules/text"
import TextText from "./zeus-modules/textText"
import TextImage from "./zeus-modules/textImage"
import MediaMedia from "./zeus-modules/mediaMedia"
import SingleImage from "./zeus-modules/singleImage"
import TextColumns from "./zeus-modules/textColumns"
import HeadingCta from "./zeus-modules/headingCta"
import MarqueeHeadline from "./zeus-modules/marqueeHeadline"
import InlineHeader from "./zeus-modules/inlineHeader";

const ZeusModules = props => {
  return (
    <div className={styles.container}>
      {props.data.map((item, i) => {
        switch (item.typeHandle) {
          case "textText":
            return <TextText key={`module-${item.id}`} data={item} />
          case "textImage":
            return <TextImage key={`module-${item.id}`} data={item} />
          case "mediaMedia":
            return <MediaMedia key={`module-${item.id}`} data={item} />
          case "singleImage":
            return <SingleImage key={`module-${item.id}`} data={item} />
          case "text":
            return <Text key={`module-${item.id}`} data={item} />
          case "video":
            return <Video key={`module-${item.id}`} data={item} />
          case "textColumns":
            return <TextColumns key={`module-${item.id}`} data={item} />
          case "headingCta":
            return <HeadingCta key={`module-${item.id}`} data={item} />
          case "marqueeHeadline":
            return <MarqueeHeadline key={`module-${item.id}`} data={item} />
          case "inlineHeader":
            return <InlineHeader key={`module-${item.id}`} data={item} />
          default:
            return (
              <div
                key={`module-${item.id}`}
                className="text-center"
                style={{ color: "#fd9494" }}
              >
                Couldn't find a component for the module at index {i}. Make sure
                there's a component file and that the GraphQL fragment has been
                updated (including <span className="mono">typeHandle</span>).
              </div>
            )
        }
      })}
    </div>
  )
}

export default ZeusModules

// ANY UPDATES TO THIS QUERY MUST ALSO BE UPDATES IN THE SECRET PAGE
// NETLIFY FUNCTION: ./functions/auth/auth.js
export const query = graphql`
  fragment ZeusModules on Craft_zeusModules_MatrixField {
      ... on Craft_zeusModules_inlineHeader_BlockType {
      id
      typeHandle
      header
    }
    ... on Craft_zeusModules_video_BlockType {
      id
      typeHandle
      columnWidth
      autoplay
      video {
        ... on Craft_AssetInterface {
          url
          extension
          kind
          mimeType
        }
      }
      posterImage {
        ... on Craft_AssetInterface {
          url
          width
          height
        }
      }
    }
    ... on Craft_zeusModules_text_BlockType {
      id
      typeHandle
      subhead
      heading
      body
      centered
      textCentered
      columnWidth
    }
    ... on Craft_zeusModules_textText_BlockType {
      id
      typeHandle
      subhead
      heading
      body
    }
    ... on Craft_zeusModules_textImage_BlockType {
      id
      typeHandle
      reverseOrder
      sectionTitle
      subhead
      heading
      body
      image {
        ... on Craft_AssetInterface {
          url
          width
          height
          kind
          mimeType
          ... on Craft_zjContent_Asset {
            altText
          }
        }
      }
    }
    ... on Craft_zeusModules_mediaMedia_BlockType {
      id
      typeHandle
      verticalAlignment
      reverseOrder
      contained
      smallMedia {
        id
        url
        width
        height
        kind
        mimeType
        ... on Craft_zjContent_Asset {
          altText
        }
      }
      largeMedia {
        id
        url
        width
        height
        kind
        mimeType
        ... on Craft_zjContent_Asset {
          altText
        }
      }
    }
    ... on Craft_zeusModules_singleImage_BlockType {
      id
      typeHandle
      columnWidth
      image {
        id
        url
        width
        height
        ... on Craft_zjContent_Asset {
          altText
        }
      }
      mobileImage {
        id
        url
        width
        height
        ... on Craft_zjContent_Asset {
          altText
        }
      }
    }
    ... on Craft_zeusModules_textColumns_BlockType {
      id
      typeHandle
      subhead
      heading
      body
      divider
      twoRows
      columns {
        ... on Craft_columns_BlockType {
          id
          text
          imageLink {
            type
            url
          }
          image {
            ... on Craft_AssetInterface {
              url
              width
              height
              ... on Craft_zjContent_Asset {
                altText
              }
            }
          }
        }
      }
    }
    ... on Craft_zeusModules_headingCta_BlockType {
      id
      typeHandle
      heading
      body
      links {
        ... on Craft_links_BlockType {
          text
          button
          externalLink
          page {
            id
            uri
            title
          }
        }
      }
    }
    ... on Craft_zeusModules_marqueeHeadline_BlockType {
      id
      typeHandle
      headline
      direction
    }
  }
`
